import React, { Fragment } from 'react';
import { templatePropTypes } from '../../utilities/commonPropTypes';
import { Shared4x3Fragment } from '../commonFragments';
import '../../global-sass/Shared4x3.scss';

const Desktop4x3 = ({
	applicableVehicle,
	carouselPosition,
	couponCode = '',
	ctaButtonData,
	description,
	
	discountDisplay = '',
	imageUrl,
	isVisible,
	offerDetails,
	promo,
	incentive = {},
	title,
	type,
	vehicleImages = [],
	width,
	height
}) => {
	return (
		<Fragment>
			{Shared4x3Fragment({
				applicableVehicle,
				carouselPosition,
				couponCode,
				ctaButtonData,
				description,
				
				discountDisplay,
				imageUrl,
				isVisible,
				offerDetails,
				promo,
				incentive,
				title,
				type,
				vehicleImages,
				width,
				height
			})}
		</Fragment>
	);
};

Desktop4x3.propTypes = templatePropTypes;

export default Desktop4x3;
